import React from 'react';
import { useLocation } from 'react-router-dom';
import { RESULT_TYPES } from '../constants/config';
import ResultPage from '../components/ResultPage';
import useScrollToTop from '../hooks/useScrollToTop';

const Error = () => {
  const location = useLocation();
  const errorMessage = location.state?.errorMessage || "Something went wrong with your booking enquiry. Please try again or contact us directly.";

  useScrollToTop();

  return (
    <ResultPage
      type={RESULT_TYPES.error}
      title="Booking Enquiry Failed"
      message={errorMessage}
    />
  );
};

export default Error;
